import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";
import { h3Regular } from "../typography/MuiTypography.style";

export const LoaderWrapper = styled.div`
  .backdrop-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%; 
    background-color: ${COLORS.cirrus_black3};
    opacity: 0.8;
    z-index: 0;
  }

  .loading-container {
    text-align: center;
    background-color: ${COLORS.cirrus_black8};
    padding: 16px 24px;
    border-radius: 8px;
    display: flex;
    box-shadow: 0 10px 13px 0 rgba(0, 0, 0, 0.25);
    position: relative;
    z-index: 1;

    .loading-text {
      color: ${COLORS.cirrus_white};
      margin: 12px 0px 12px 12px;
      ${h3Regular}
    }
  }
`;
